import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class GlobalUserService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getUsers({skip, limit, id, user}) {
        return Vue.axios.get(`${API_HOST}/api/GlobalUser`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                limit: limit,
                skip: skip,
                id: id ? id : null,
                userId: user
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    checkUsername(username) {
        return Vue.axios.get(`${API_HOST}/api/CheckGlobalUser`, {
            params: {
                id: username
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    addUser({userFullName: userFullName, username, password, type, unit, canSignOnBehalfOfOrganization}) {
        return Vue.axios.post(`${API_HOST}/api/GlobalUser`, {
            UserFullName: userFullName,
            Username: username,
            Password: password,
            UserType: type,
            GlobalUnitId: unit.id,
            CanSignOnBehalfOfOrganization: canSignOnBehalfOfOrganization
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    editUser({userFullName, username, password, type, unitId, canSignOnBehalfOfOrganization}) {
        return Vue.axios.put(`${API_HOST}/api/GlobalUser`, {
            UserFullName: userFullName,
            Password: password,
            UserType: type,
            GlobalUnitId: unitId,
            CanSignOnBehalfOfOrganization: canSignOnBehalfOfOrganization
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: username
            }
        })
    }
}

export default new GlobalUserService()